import { useMutation } from "@tanstack/react-query";

import { GraphQLAPI, queries } from "@examspark/api";
import {
  ClassroomUnit,
  CreateClassroomUnitInput,
  DeleteClassroomUnitInput,
  IDSK,
  UpdateClassroomUnitInput,
} from "@examspark/types";

import { useAuthorizationContext } from "../../hooks/useAuthorizationContext";

export const useMutationCreateClassroomUnit = () => {
  return useMutation({
    mutationFn: async (input: CreateClassroomUnitInput) => {
      return await GraphQLAPI.query({
        query: queries.classroom.createClassroomUnit,
        variables: {
          input,
        },
      });
    },
  });
};

export const useMutationDeleteClassroomUnit = () => {
  return useMutation({
    mutationFn: async (input: DeleteClassroomUnitInput) => {
      return await GraphQLAPI.query({
        query: queries.classroom.deleteClassroomUnit,
        variables: {
          input,
        },
      });
    },
  });
};

export const useMutationUpdateClassroomUnit = () => {
  return useMutation({
    mutationFn: async (input: UpdateClassroomUnitInput) => {
      return await GraphQLAPI.query({
        query: queries.classroom.updateClassroomUnit,
        variables: {
          input,
        },
      });
    },
  });
};

export const useMutationGetClassroomUnit = () => {
  const authorizationContext = useAuthorizationContext();

  return useMutation({
    mutationFn: async (input: IDSK) => {
      const result = (await GraphQLAPI.query({
        query: queries.classroom.getClassroomUnit,
        variables: {
          input,
          authorizationContext,
        },
      })) as any;

      return result.data.getClassroomUnit as ClassroomUnit | null;
    },
  });
};
